export default {
  'overflow-hidden': {
    overflow: 'hidden',
  },
};
